export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getInjector: state => (task_id) => {

        // Get list
        let lst = Object.values(state.injectors).filter((ut) => (ut.task_id === task_id));

        // Return tasks list
        return lst ? lst[0] : false
    },

    /**
     * Get injector by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return injector list
        return state.injectors[id];
    }

}
